import { APPCONFIG } from '@/app.config';
import { APIS } from '@Config/apis';
import userAuth from '@Config/userauth';
import { DEFAULT_HEADER } from '@Config/userToken';
import { apiFetch } from '@Shared/Api/apiClient';
import { truncate } from '@Shared/Utils';
import { TipoCertificado } from '@Shared/Utils/Models/TipoCertificadoEnum';
import { formatDate } from '@Shared/Utils/dateHelpers';

class PagosYRetencionesService {
  // Obtener datos de pagos
  async getPagosYLiquidaciones(params) {
    const { PRODUCERURL } = APPCONFIG.ENDPOINTS;
    const requestOptions = {
      method: 'POST',
      headers: DEFAULT_HEADER.get(),
      body: JSON.stringify(params)
    };

    const response = await apiFetch(`${PRODUCERURL}api/Settlement/payments`, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (Array.isArray(data.data)) {
      return {
        data: data.data.map(item => ({
          numero: item.numero,
          fecha: formatDate(item.fecha, 'dd/MM/yyyy'),
          numeroSolicitudPago: item.referencia,
          importePagado: item.importePagado ? `$ ${truncate(item.importePagado, 2)}` : '',
          ibOsMunicip: item.ibOsMunicip || 0,
          referencia: item.referencia,
          tipoPago: item.tipoPago,
          ganancias: item.ganancias || 0,
          cuit: item.cuit,
          original: item
        })),
        total: data.total
      };
    }

    return { data: [], total: 0 };
  }

  // Descargar certificado
  async downloadCertificado(cuit, numeroPago, tipoCertificado) {
    const requestOptions = {
      method: 'GET',
      headers: DEFAULT_HEADER.get(),
    };

    const response = await apiFetch(`${APIS.URLS.DOWNLOAD_CERTIFICADO_PAGOSYLIQ}?cuit=${cuit}&numeroPago=${numeroPago}&tipoCertificado=${TipoCertificado[tipoCertificado]}`, requestOptions);

    if (!response.ok) {
      let errorMessage = 'Error al intentar descargar el certificado.';
      try {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const error = await response.json();
          errorMessage = error?.Message || error?.message || errorMessage;
        } else {
          errorMessage = await response.text();
          if (!errorMessage || errorMessage.trim() === '') {
            errorMessage = 'Error al intentar descargar el certificado.';
          }
        }
      } catch (parseError) {
        errorMessage = `Error ${response.status}: Error al intentar descargar el certificado.`;
      }
      throw new Error(errorMessage);
    }

    return response;
  }

  // Exportar pagos y liquidaciones a Excel
  async exportPagosYLiquidaciones(params) {
    const { PRODUCERURL } = APPCONFIG.ENDPOINTS;

    const response = await apiFetch(`${PRODUCERURL}api/exports`, {
      method: 'POST',
      headers: DEFAULT_HEADER.get(),
      body: JSON.stringify({ grid: 'PagosYRetenciones', format: 'Xlsx', payload: params })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response;
  }

  // Construir parámetros de búsqueda
  buildSearchParams(filters, sort, page, pageSize, poliza = null) {
    return {
      producerCuit: userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
      next: pageSize,
      poliza: poliza > 0 ? poliza : null,
      offset: page * pageSize,
      gridFilters: filters,
      sort: sort.length === 0 ? null : sort[0],
    };
  }

  // Construir parámetros para exportación
  buildExportParams(searchCriteriaText, columns) {
    return {
      producerCuit: userAuth.isProducer() ? userAuth.cuit() : userAuth.cuitProducer(),
      filters: searchCriteriaText?.replace(/['"]+/g, "\\'"),
      columns: JSON.stringify(columns)
    };
  }
}

const pagosYLiquidacionesService = new PagosYRetencionesService();
export default pagosYLiquidacionesService;
